import {
  PageHeader,
  Row,
  Col,
  Tag,
  Typography,
  Tooltip,
  Card,
  Button,
  Space,
  message,
  Popconfirm,
} from "antd";
import { NOTFOUND } from "dns";
import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import FormBar from "../../shared/layouts/formbar.layout";
import TabsLayout from "../../shared/layouts/tabs.layout";
import TableLayout from "../../shared/layouts/table.layout";
import { RootState } from "../../shared/constants";
import {
  annoucementStatuses,
  annoucementTableConfigs,
} from "./components/config";
import {
  announcementAction,
  getAnnouncementList,
  getAudienceList,
  reset,
} from "../../core/store/reducers/annoucements.slice";
import { useHistory, useParams } from "react-router-dom";
import {
  ROUTE_CREATE_AUDIENCE,
  ROUTE_EDIT_AUDIENCE,
  ROUTE_VIEW_AUDIENCE_QUERY,
} from "../../core/route/ui.routes";
import { setBlurModal } from "../../core/store/reducers/settings.slice";
import CreateAudienceCSV from "./components/create-audience-csv.component";
import CreateEditAnnouncement from "./components/create-edit-announcement.component";
import moment from "moment";

const tabLabelsEnum: any = {
  ANNOUNCEMENTS: "Announcements",
  SAVED_AUDIENCE: "Saved Audience",
};
const defaultDateGap = [moment().subtract(1, "month").startOf('month').clone(), moment().add(1, "month").endOf('month').clone()];
function AnnouncementsConfigPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();
  const [filters, setFilters] = useState({range: defaultDateGap} as any);
  const [selectedTab, setSelectedTab] = useState(null as any);
  const [csvUploadVisible, setCsvUploadVisible] = useState(false as boolean);
  const [selectedAudience, setSelectedAudience] = useState(null as any);
  const [showCreateAnnouncement, setShowCreateAnnouncement] = useState(
    false as boolean
  );
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null as any);

  useEffect(() => {
    if (
      params?.tab &&
      Object.keys(tabLabelsEnum)?.indexOf(params?.tab) !== -1
    ) {
      let tab: any = Object.keys(tabLabelsEnum)?.indexOf(params?.tab) + 1;
      onTabChange(tab);
    } else {
      onTabChange(1);
    }
  }, [params]);
  const { loading, annoucements, audiences, pagination } = useSelector(
    (state: RootState) => state.annoucements
  );
  const [listData, setListData] = useState([] as any);
  const [columns, setColumns] = useState([] as any);
  const [formData, setFormData] = useState([] as any);
  const tabLabels = [tabLabelsEnum.ANNOUNCEMENTS, tabLabelsEnum.SAVED_AUDIENCE];

  useEffect(() => {
    if (selectedTab == tabLabelsEnum.ANNOUNCEMENTS) {
      setListData(annoucements);
    }
    if (selectedTab == tabLabelsEnum.SAVED_AUDIENCE) {
      setListData(audiences);
    }
  }, [audiences, annoucements, selectedTab]);
  useEffect(() => {
    let formDataTemp: any = {
      onFinish: () => {},
      onFinishFailed: () => {},
      onValuesChange: filterFormSubmit,
      initialValues: { ...filters },
      filtersApplied: filters
        ? Object.keys(
            Object.fromEntries(
              Object.entries(filters).filter(([_, v]) => v != null)
            )
          ).length
        : 0,
      setValues: {
        ...filters,
      },
      formElements: [],
    };
    if (selectedTab == tabLabelsEnum.ANNOUNCEMENTS) {
      formDataTemp.formElements =
        annoucementTableConfigs.annoucement.filterForm;
      formDataTemp.setValues = {
        range: defaultDateGap,
        ...formDataTemp?.setValues
      }
      setColumns(
        annoucementTableConfigs.annoucement.columns(annoucementActions)
      );
      setFormData(formDataTemp);
    }
    if (selectedTab == tabLabelsEnum.SAVED_AUDIENCE) {
      formDataTemp.formElements = annoucementTableConfigs.audience.filterForm;
      setColumns(annoucementTableConfigs.audience.columns(onEditAudience, onViewAudienceQuery));
      setFormData(formDataTemp);
    }
  }, [selectedTab, pagination]);
  function onEditAudience(audience: any) {
    if (audience.audience_type == "query") {
      history.push(ROUTE_EDIT_AUDIENCE(audience?.audience_id));
    } else {
      setSelectedAudience(audience);
      setCsvUploadVisible(true);
    }
  }
  function onViewAudienceQuery(audience: any) {
    if (audience.audience_type == "query") {
      history.push(ROUTE_VIEW_AUDIENCE_QUERY(audience?.audience_id));
    }
  }
  function onEditAnnouncement(annoucement: any) {
    setSelectedAnnouncement(annoucement);
  }
  useEffect(() => {
    if (selectedAnnouncement?.announcement_id) {
      setShowCreateAnnouncement(true);
    } else {
      setShowCreateAnnouncement(false);
    }
  }, [selectedAnnouncement]);
  function onDeleteAnnouncement(annoucement: any) {
    dispatch(
      announcementAction({
        announcement_id: annoucement?.announcement_id,
        action: "delete",
      })
    ).then((val: any) => {
      if (val?.payload?.data?.statusCode == 200) {
        message.success("Announcement Deleted Successfully!");
        loadList(pagination?.offset);
      }
    });
  }
  function onStopAnnouncement(annoucement: any) {
    dispatch(
      announcementAction({
        announcement_id: annoucement?.announcement_id,
        action: "stop",
      })
    ).then((val: any) => {
      if (val?.payload?.data?.statusCode == 200) {
        message.success("Announcement Stopped Successfully!");
        loadList(pagination?.offset);
      }
    });
  }
  function annoucementActions(rec: any) {
    if (rec?.status == annoucementStatuses.SCHEDULED) {
      //edit, delete
      return (
        <>
          <Space>
            <a onClick={() => onEditAnnouncement(rec)}>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.8 6.925L12.55 2.725L13.95 1.325C14.3333 0.941667 14.8043 0.75 15.363 0.75C15.921 0.75 16.3917 0.941667 16.775 1.325L18.175 2.725C18.5583 3.10833 18.7583 3.571 18.775 4.113C18.7917 4.65433 18.6083 5.11667 18.225 5.5L16.8 6.925ZM15.35 8.4L4.75 19H0.5V14.75L11.1 4.15L15.35 8.4Z"
                  fill="#4DA9D0"
                />
              </svg>
            </a>
            &nbsp;&nbsp;&nbsp;
            <Popconfirm
              title="Are you sure to delete this Announcement?"
              onConfirm={() => onDeleteAnnouncement(rec)}
              okText="Yes"
              cancelText="No"
            >
              <a>
                <svg
                  width="13"
                  height="18"
                  viewBox="0 0 13 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.46108 16C1.46108 17.1 2.22937 18 3.1684 18H9.99767C10.9367 18 11.705 17.1 11.705 16V4H1.46108V16ZM12.5586 1H9.57084L8.71718 0H4.44889L3.59523 1H0.607422V3H12.5586V1Z"
                    fill="black"
                  />
                </svg>
              </a>
            </Popconfirm>
          </Space>
        </>
      );
    }
    if (rec?.status == annoucementStatuses.ACTIVE) {
      //stop
      return (
        <>
          <Popconfirm
            title="Are you sure to stop this Announcement?"
            onConfirm={() => onStopAnnouncement(rec)}
            okText="Yes"
            cancelText="No"
          >
            <a>
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0.0703125C8.8174 0.0703125 5.76516 1.33459 3.51472 3.58503C1.26428 5.83547 0 8.88771 0 12.0703C0 15.2529 1.26428 18.3052 3.51472 20.5556C5.76516 22.806 8.8174 24.0703 12 24.0703C15.1826 24.0703 18.2348 22.806 20.4853 20.5556C22.7357 18.3052 24 15.2529 24 12.0703C24 8.88771 22.7357 5.83547 20.4853 3.58503C18.2348 1.33459 15.1826 0.0703125 12 0.0703125ZM12 21.8203C9.41414 21.8203 6.93419 20.7931 5.10571 18.9646C3.27723 17.1361 2.25 14.6562 2.25 12.0703C2.25 9.48445 3.27723 7.0045 5.10571 5.17602C6.93419 3.34754 9.41414 2.32031 12 2.32031C14.5859 2.32031 17.0658 3.34754 18.8943 5.17602C20.7228 7.0045 21.75 9.48445 21.75 12.0703C21.75 14.6562 20.7228 17.1361 18.8943 18.9646C17.0658 20.7931 14.5859 21.8203 12 21.8203ZM7.5 7.57031H16.5V16.5703H7.5V7.57031Z"
                  fill="#E1454E"
                />
              </svg>
            </a>
          </Popconfirm>
        </>
      );
    }
    return <>--</>;
  }
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  const onPageChange = (e: any, pageSize: any) => {
    let offset = (e - 1) * pagination.limit;
    loadList(offset);
  };
  const onTabChange = (e: any) => {
    setListData([]);
    dispatch(reset());
    
    if (selectedTab == tabLabelsEnum.ANNOUNCEMENTS) {
      setFilters({range: defaultDateGap});
    }else{
      setFilters({});
    }
    let tab = tabLabels[e - 1];
    setSelectedTab(tab);
  };
  useEffect(() => {
    loadList();
  }, [filters, selectedTab]);

  const loadList = (offset: number = 0) => {
    if (selectedTab == tabLabelsEnum.ANNOUNCEMENTS) {
      let filter = {} as any;
      if (filters?.searchTerm && filters?.searchTerm != "") {
        filter.searchTerm = filters?.searchTerm;
      }
      if (filters?.status && filters?.status != "") {
        filter.status = filters?.status;
      }
      if (filters?.range && filters?.range?.length == 2) {
        if (filters?.range[0] && filters?.range[1]) {
          filter.from_date = moment(filters?.range[0]).format("YYYY-MM-DD");
          filter.to_date = moment(filters?.range[1]).format("YYYY-MM-DD");
        } else {
          return;
        }
      }
      dispatch(
        getAnnouncementList({
          ...pagination,
          offset: offset,
          ...filter,
        })
      );
    }
    if (selectedTab == tabLabelsEnum.SAVED_AUDIENCE) {
      let filter = {} as any;
      if (filters?.searchTerm && filters?.searchTerm != "") {
        filter.searchTerm = filters?.searchTerm;
      }
      dispatch(
        getAudienceList({
          ...pagination,
          offset: offset,
          ...filter,
        })
      );
    }
    // dispatch(
    //   fetchTicketsList({
    //     ...pagination,
    //     offset: offset,
    //     status_id: selectedStatus,
    //     ...filter,
    //     ...sorterData,
    //   })
    // );
  };
  async function filterFormSubmit(changed: any, all: any) {
    setFilters(all);
  }

  var allTabs = tabLabels.map((val: any) => {
    return {
      title: val,
      key: val,
      component: (
        <>
          <Row className="content-area">
            <Col span={24}>
              <TableLayout
                pageType="withTab"
                defaultCurrentPage={pagination.offset / pagination.limit + 1}
                loading={loading}
                buttonEvt={() => {}}
                dataSource={listData}
                filters="multiple"
                columns={columns}
                onChange={(e, ee) => onPageChange(e, ee)}
                type="morefilters"
                total={pagination.total}
                showTotal={true}
                pagination={{
                  position: ["none", "none"],
                  pageSize: pagination.limit,
                }}
                paginationPosition="top"
                formData={formData}
                maxWidth={1500}
                defaultPageSize={10}
                showSizeChangerFlag={false}
              />
            </Col>
          </Row>
        </>
      ),
    };
  });

  return (
    <Fragment>
      <PageHeader
        ghost={false}
        className="pb-0"
        title={
          <Row
            style={screenType.mobile ? { paddingLeft: "25px" } : {}}
            align="middle"
          >
            <Col flex="auto" className="title-text">
              Announcements Config
            </Col>
          </Row>
        }
        extra={
          <Row align="middle">
            <Col className="title-text">
              <Space>
                <Button
                  key="1"
                  className="ant-btn-hover"
                  onClick={() => {
                    // setUploadFileVisible(true);
                    history.push(ROUTE_CREATE_AUDIENCE);
                  }}
                >
                  Create New Audience
                </Button>
                <Button
                  key="2"
                  className="ant-btn-hover"
                  onClick={() => {
                    setShowCreateAnnouncement(true);
                  }}
                >
                  Create New Announcement
                </Button>
              </Space>
            </Col>
          </Row>
        }
      ></PageHeader>

      <Row>
        <Col span={24} className="crm-tabs-2">
          {formData?.formElements && selectedTab && (
            <TabsLayout AllTabs={allTabs} onChange={onTabChange}></TabsLayout>
          )}
        </Col>
      </Row>
      {csvUploadVisible && (
        <CreateAudienceCSV
          selectedAudience={selectedAudience}
          formVisible={csvUploadVisible}
          setFormVisible={setCsvUploadVisible}
          returnType={2}
          reloadList={() => {
            setSelectedAudience(null);
            loadList(pagination?.offset);
          }}
        ></CreateAudienceCSV>
      )}
      {showCreateAnnouncement && (
        <CreateEditAnnouncement
          selectedAnnouncement={selectedAnnouncement}
          formVisible={showCreateAnnouncement}
          setFormVisible={setShowCreateAnnouncement}
          onClose={() => {
            setShowCreateAnnouncement(false);
            setSelectedAnnouncement(null);
          }}
          reloadList={() => {
            setSelectedAnnouncement(null);
            loadList(pagination?.offset);
          }}
        ></CreateEditAnnouncement>
      )}
    </Fragment>
  );
}
export default AnnouncementsConfigPage;
